import { graphql } from "../../gql";

export const USER_LIST = graphql(`
  query UserList {
    userList {
      ...USER_FIELDS
    }
  }
`);

export const USER_ME = graphql(`
  query UserMe {
    userMe {
      email
      createdAt
      emailVerifiedAt
      firstName
      id
      lastName
      updatedAt
      role
      organization {
        name
        subscription {
          status
          planName
        }
        manuallyManagedPlan
      }
    }
  }
`);
